import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const MOVEMENT_ROUTINES: Partial<Routine>[] = [
  {
    id: "desk-break-movement",
    title: "Desk Break Movement",
    symbol: "🏃",
    description: "Combat sedentary behavior with regular movement breaks",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[3].value,
    steps: [
      {
        id: "movement-desk-1",
        title: "Set a timer",
        description: "Schedule an alert for every 50-60 minutes of sitting",
      },
      {
        id: "movement-desk-2",
        title: "Full-body stretch",
        description: "Stand and stretch your arms, legs, back, and neck for 2-3 minutes",
      },
      {
        id: "movement-desk-3",
        title: "Brief activity",
        description: "Do 20 jumping jacks, march in place, or walk a lap around your space",
      },
    ],
  },
  {
    id: "joint-mobility-routine",
    title: "Joint Mobility Routine",
    symbol: "🏃",
    description: "Maintain and improve range of motion in all major joints",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[4].value,
    steps: [
      {
        id: "movement-joint-1",
        title: "Neck and shoulders",
        description: "Gently move your neck through its range and circle your shoulders",
      },
      {
        id: "movement-joint-2",
        title: "Hip and spine mobility",
        description: "Perform gentle rotations, bends, and stretches for lower body",
      },
      {
        id: "movement-joint-3",
        title: "Wrist and ankle circles",
        description: "Move your wrists and ankles in both directions to maintain flexibility",
      },
    ],
  },
  {
    id: "weekend-nature-movement",
    title: "Weekend Nature Movement",
    symbol: "🏃",
    description: "Connect with nature while being physically active",
    dailyRoutine: false,
    selectedDays: [{ day: "saturday", datetime: "09:00:00.000Z" }],
    color: RoutineColors[5].value,
    steps: [
      {
        id: "movement-nature-1",
        title: "Outdoor location",
        description: "Choose a park, trail, or natural area to visit",
      },
      {
        id: "movement-nature-2",
        title: "Active exploration",
        description: "Walk, hike, or cycle for at least 30-45 minutes",
      },
      {
        id: "movement-nature-3",
        title: "Mindful moments",
        description: "Pause occasionally to fully observe your surroundings using all senses",
      },
    ],
  },
];
